"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsernameTakenError = exports.AuthenticationError = exports.FluxClaimsSchema = exports.UserStateType = void 0;
exports.providerForLoginMethod = providerForLoginMethod;
const constants_1 = require("@buildwithflux/constants");
const shared_1 = require("@buildwithflux/shared");
const zod_1 = require("zod");
function providerForLoginMethod(loginMethod) {
    return loginMethod.type;
}
exports.UserStateType = zod_1.z.enum([
    "uninitialized",
    "initializing",
    "authenticated",
    "anonymous",
    "partiallyAuthenticated",
    "loggedOut",
]);
exports.FluxClaimsSchema = zod_1.z.object({
    superadmin: zod_1.z.boolean().optional().describe("Super administrator access"),
    admin: zod_1.z.boolean().optional().describe("Administrator access"),
    internal: zod_1.z.boolean().optional().describe("Internal Flux team member access"),
});
class AuthenticationError extends Error {
    code = constants_1.FluxErrorCodes.UserSignUpError;
    constructor(message, cause) {
        super(...(0, shared_1.concatErrorArgs)(message ?? `Authentication error during sign up`, cause));
    }
}
exports.AuthenticationError = AuthenticationError;
class UsernameTakenError extends AuthenticationError {
    constructor(cause) {
        super("Username already taken during sign up", cause);
    }
}
exports.UsernameTakenError = UsernameTakenError;
//# sourceMappingURL=auth.js.map